import script from "./FetchingBox.vue?vue&type=script&setup=true&lang=js"
export * from "./FetchingBox.vue?vue&type=script&setup=true&lang=js"

import "./FetchingBox.vue?vue&type=style&index=0&id=3a02080e&scoped=true&lang=css"

import exportComponent from "/home/tml/work/WP-plugins/wpaprsdb/wpaprsdb/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a02080e"]])

export default __exports__